import React from "react"
import style from "./style.module.scss"
import SeatIcon from "@material-ui/icons/EventSeat"
import WalkIcon from "@material-ui/icons/DirectionsWalk"
import WcIcon from "@material-ui/icons/Wc"
import classnames from "classnames"

export enum MenuItemType {
  FACILITY = "facility",
  CATEGORY = "category",
  ROUTE = "route",
  SEAT = "seat"
}

const menus: {
  type: MenuItemType,
  Icon: typeof SeatIcon,
  label: string,
}[] = [{
  type: MenuItemType.CATEGORY,
  Icon: WcIcon,
  label: "施設",
}, {
  type: MenuItemType.SEAT,
  Icon: SeatIcon,
  label: "座席",
}, {
  type: MenuItemType.ROUTE,
  Icon: WalkIcon,
  label: "案内",
}]

type Props = {
  onItemClick: (item: MenuItemType) => void,
  selectedItem: MenuItemType | null
}

/**
 * ３つアイコンが並んだメニュー
 */
export default function Menu ({ onItemClick, selectedItem, }: Props) {
  return (
    <div className={style.frame}>
      {(menus.map((item, key) => {
        return (
          <div
            className={classnames({
              [style.item]: true,
              [style.selected]: item.type === selectedItem,
            })}
            key={key}
            onClick={() => onItemClick(item.type)}
          >
            <div className={style.circle}>
              <div className={style.icon}>
                <item.Icon/>
              </div>
              <div className={style.label}>{item.label}</div>
            </div>
          </div>
        )
      }))}
    </div>
  )
}
